import { FIELD_REQUIRED } from 'form/validation/validationMessages'
import * as Yup from 'yup'

export const CreateNewLinkSchema = Yup.object().shape({
    link: Yup.string().required(FIELD_REQUIRED),
})
